/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: 1r7jyUeHxY8n

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_data_binding.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicMessagePartPopoverContentBlock.module.css"; // plasmic-import: 1r7jyUeHxY8n/css

createPlasmicElementProxy;

export type PlasmicMessagePartPopoverContentBlock__VariantMembers = {};
export type PlasmicMessagePartPopoverContentBlock__VariantsArgs = {};
type VariantPropType =
  keyof PlasmicMessagePartPopoverContentBlock__VariantsArgs;
export const PlasmicMessagePartPopoverContentBlock__VariantProps =
  new Array<VariantPropType>();

export type PlasmicMessagePartPopoverContentBlock__ArgsType = {
  title?: React.ReactNode;
  content?: React.ReactNode;
};
type ArgPropType = keyof PlasmicMessagePartPopoverContentBlock__ArgsType;
export const PlasmicMessagePartPopoverContentBlock__ArgProps =
  new Array<ArgPropType>("title", "content");

export type PlasmicMessagePartPopoverContentBlock__OverridesType = {
  root?: Flex__<"div">;
  pre?: Flex__<"pre">;
};

export interface DefaultMessagePartPopoverContentBlockProps {
  title?: React.ReactNode;
  content?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicMessagePartPopoverContentBlock__RenderFunc(props: {
  variants: PlasmicMessagePartPopoverContentBlock__VariantsArgs;
  args: PlasmicMessagePartPopoverContentBlock__ArgsType;
  overrides: PlasmicMessagePartPopoverContentBlock__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_w2GXN278dkQ2gQTVQnPehW",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox__ifvFk)}>
        {renderPlasmicSlot({
          defaultContents: "INPUT",
          value: args.title,
          className: classNames(sty.slotTargetTitle),
        })}
      </div>
      <div className={classNames("all", sty.freeBox__nWwxe)}>
        <pre
          data-plasmic-name={"pre"}
          data-plasmic-override={overrides.pre}
          className={classNames("all", "pre", "pre__w2GXN", sty.pre)}
        >
          {renderPlasmicSlot({
            defaultContents:
              '{\n  "project": {\n    "components": true,\n    "screenBreakpoints": false,\n    "globalVariants": false,\n    "tokens": false\n  },\n  "components": [],\n  "elements": [],\n  "tokens": []\n}',
            value: args.content,
            className: classNames(sty.slotTargetContent),
          })}
        </pre>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "pre"],
  pre: ["pre"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  pre: "pre";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMessagePartPopoverContentBlock__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMessagePartPopoverContentBlock__VariantsArgs;
    args?: PlasmicMessagePartPopoverContentBlock__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicMessagePartPopoverContentBlock__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicMessagePartPopoverContentBlock__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMessagePartPopoverContentBlock__ArgProps,
          internalVariantPropNames:
            PlasmicMessagePartPopoverContentBlock__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicMessagePartPopoverContentBlock__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMessagePartPopoverContentBlock";
  } else {
    func.displayName = `PlasmicMessagePartPopoverContentBlock.${nodeName}`;
  }
  return func;
}

export const PlasmicMessagePartPopoverContentBlock = Object.assign(
  // Top-level PlasmicMessagePartPopoverContentBlock renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    pre: makeNodeComponent("pre"),

    // Metadata about props expected for PlasmicMessagePartPopoverContentBlock
    internalVariantProps: PlasmicMessagePartPopoverContentBlock__VariantProps,
    internalArgProps: PlasmicMessagePartPopoverContentBlock__ArgProps,
  }
);

export default PlasmicMessagePartPopoverContentBlock;
/* prettier-ignore-end */
